export const PRODUCT_SEGMENTS_COLORS = {
  1: '#D68F8F',
  2: '#8F9FD6',
  3: '#99D68F',
  4: '#8FD1D6',
  5: '#E6DE90',
  9: '#BF8FD6',
  10: '#5A5A5A',
};
